import { Stack, Tooltip, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import type { PartnerLogoDto } from "../../../../../customer-experience/src/lib/ShiOneClient";

export function PartnerNames({
  partners,
}: Readonly<{ partners: PartnerLogoDto[] | undefined }>) {
  const partnerNames =
    partners
      ?.map((partner) => partner.partner)
      .filter((name): name is string => !!name) ?? [];

  if (partnerNames.length === 0) {
    return null;
  }

  const hasMultiplePartners = partnerNames.length > 1;

  return (
    <Tooltip
      arrow
      placement="top"
      title={
        hasMultiplePartners ? (
          <Stack>
            {partnerNames.map((name) => (
              <Typography key={name} variant="caption">
                {name}
              </Typography>
            ))}
          </Stack>
        ) : (
          ""
        )
      }
    >
      <Stack
        direction="row"
        alignItems="center"
        sx={{ flexShrink: 0 }}
        {...(hasMultiplePartners && {
          tabIndex: 0,
          role: "group",
          "aria-label": `Partners: ${partnerNames.join(", ")}`,
        })}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: "0.75rem",
            textTransform: "uppercase",
            marginBottom: "-1px",
          }}
        >
          {partnerNames[0]}
        </Typography>
        {hasMultiplePartners && (
          <AddIcon
            sx={{
              fontSize: "0.875rem",
              color: "text.secondary",
              ml: 0.25,
            }}
          />
        )}
      </Stack>
    </Tooltip>
  );
}
